import { Branch } from '@medprev-web-app/api-graphql-client';

import { BranchAvatar } from './branch-avatar.component';

import { AnalyticsBranchPageEnum } from '@/app/(main)/(pages)/_enums/analytics-branch-page.enum';
import { BranchContact } from '@/app/(main)/(pages)/_components/branches-section/branch-profile/branch-contact.component';
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatBranchName } from '@/utils/formatters/branch';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import useIsMobile from '@/hooks/use-is-mobile.hook';
import { BranchOpeningHours } from '@/app/(main)/(pages)/_components/branches-section/branch-profile/branch-opening-hours.component';

interface BranchProfileModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  branch: Branch;
  pageFrom: AnalyticsBranchPageEnum;
}

export const BranchProfileModal = ({
  open,
  onOpenChange,
  branch,
  pageFrom,
}: BranchProfileModalProps) => {
  const branchName = formatBranchName(branch.name as string);
  const isMobile = useIsMobile();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={isMobile ? 'bottom' : 'centerFit'}
        closingTagPosition="right"
        hasHeader
        className="p-0 border-none overflow-x-hidden outline-none outline-offset-0"
      >
        <SheetHeader>
          <div className="flex justify-between gap-2 px-6 pt-5 pb-4 items-center">
            <SheetTitle>
              <Typography
                variant={TypographyVariant.MODAL_TITLE}
                className="text-xl"
              >
                Unidade de atendimento
              </Typography>
            </SheetTitle>

            <SheetClose asChild className="self-start">
              <ModalCloseButton skipInitialFocus />
            </SheetClose>
          </div>
        </SheetHeader>

        <div className="max-h-[70vh] sm:max-h-[60vh] overflow-y-auto overflow-x-hidden pt-4 px-6 pb-6 flex flex-col items-center gap-4">
          <BranchAvatar branch={branch} />
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            className="text-center mb-3"
          >
            {branchName}
          </Typography>

          <hr className="w-full bg-gray-300" />

          <BranchContact branch={branch} pageFrom={pageFrom} className="mt-3" />

          <BranchOpeningHours branch={branch} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
